
      var _image, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIosIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 61,
  height: 26,
  textRendering: "geometricPrecision",
  viewBox: "0 0 61 26"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
  id: "IosIcon_0476552ee01d2702__a",
  width: 61,
  height: 26,
  x: 0,
  y: 0,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAaCAMAAAAzFaRVAAAAJFBMVEVMaXH///////////////////////////////////////////9tKdXLAAAAC3RSTlMAhtw7WyAQo+9wv5+I+9sAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAACOSURBVHja1ZSxEsMwCEMtsIMd/f//ts3lkiuZZC+tFqZ3EmBcyl9pG+HTcDP2Ok0H60JwYK5fB0Z7Rx+AbF87P4o4imk8yKNeRWmgndQlmkDvD7gJE0twoUvBE9zLCm3SrnPyvim4ZXNo685jC8HdH7Q09X1pbv792DTr3DnVO8XtTupHXo2nbOV7+Qm9ALxNA35FlXH/AAAAAElFTkSuQmCC",
  width: 61,
  height: 26,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAaCAMAAAAzFaRVAAAAJFBMVEVMaXH///////////////////////////////////////////9tKdXLAAAAC3RSTlMAhtw7WyAQo+9wv5+I+9sAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAACOSURBVHja1ZSxEsMwCEMtsIMd/f//ts3lkiuZZC+tFqZ3EmBcyl9pG+HTcDP2Ok0H60JwYK5fB0Z7Rx+AbF87P4o4imk8yKNeRWmgndQlmkDvD7gJE0twoUvBE9zLCm3SrnPyvim4ZXNo685jC8HdH7Q09X1pbv792DTr3DnVO8XtTupHXo2nbOV7+Qm9ALxNA35FlXH/AAAAAElFTkSuQmCC",
  preserveAspectRatio: "none",
  style: {
    imageRendering: "crisp-edges"
  }
})), /*#__PURE__*/React.createElement("mask", {
  id: "IosIcon_0476552ee01d2702__b",
  width: 61,
  height: 26,
  x: 0,
  y: 0,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAaCAMAAAAzFaRVAAAABlBMVEVMaXH///+a4ocPAAAAAXRSTlMAQObYZgAAAAlwSFlzAAAD6AAAA+gBtXtSawAAACpJREFUeNpjYBgFo4AWgBEE4BQ5mqGAIs2jugfCcjpHOIW6GSjROwrgAACFZQCU65G+PQAAAABJRU5ErkJggg==",
  width: 61,
  height: 26,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAaCAMAAAAzFaRVAAAABlBMVEVMaXH///+a4ocPAAAAAXRSTlMAQObYZgAAAAlwSFlzAAAD6AAAA+gBtXtSawAAACpJREFUeNpjYBgFo4AWgBEE4BQ5mqGAIs2jugfCcjpHOIW6GSjROwrgAACFZQCU65G+PQAAAABJRU5ErkJggg==",
  preserveAspectRatio: "none",
  style: {
    imageRendering: "crisp-edges"
  }
}))), _image || (_image = /*#__PURE__*/React.createElement("image", {
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAaCAMAAAAzFaRVAAAAPFBMVEVMaXEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC1b/zcwfi8gPvPp/nCjfvproBqAAAADnRSTlMAvqDvEIBgIEHfz49wMGeLi9AAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAADsSURBVHja7ZTbbgMhDES5GwNrCPn/fy2YkIYVSqMqL1E7D+yAOMIe0Arxr0/TISW0j7EBUTpe6j4oeIX2RG3foYkV2wrg8Pa081pKzULkWup1oTsQXUJGFFHyXp3pwmOt4/NIJyIuWpI2bQjdww4+T5iWJOfEC0uE7tx1XmaXhdazzF6DCb3r4Namn6T2QKc2Otl59SqNt63QK+dL8zjtrvK80JE0N6r4AtiaW5Bb1YX2HNQRuVxJyh8Q17PXzO+Hj9dixwMhBGFw+n3Mm7c2gtLW9JpTuPsfL3zKAGz9m/Qde8m/4i+s/Nd/TF/Digu2wmvf5QAAAABJRU5ErkJggg==",
  width: 61,
  height: 26,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAaCAMAAAAzFaRVAAAAPFBMVEVMaXEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC1b/zcwfi8gPvPp/nCjfvproBqAAAADnRSTlMAvqDvEIBgIEHfz49wMGeLi9AAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAADsSURBVHja7ZTbbgMhDES5GwNrCPn/fy2YkIYVSqMqL1E7D+yAOMIe0Arxr0/TISW0j7EBUTpe6j4oeIX2RG3foYkV2wrg8Pa081pKzULkWup1oTsQXUJGFFHyXp3pwmOt4/NIJyIuWpI2bQjdww4+T5iWJOfEC0uE7tx1XmaXhdazzF6DCb3r4Namn6T2QKc2Otl59SqNt63QK+dL8zjtrvK80JE0N6r4AtiaW5Bb1YX2HNQRuVxJyh8Q17PXzO+Hj9dixwMhBGFw+n3Mm7c2gtLW9JpTuPsfL3zKAGz9m/Qde8m/4i+s/Nd/TF/Digu2wmvf5QAAAABJRU5ErkJggg==",
  preserveAspectRatio: "none"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  shapeRendering: "crispEdges"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  mask: "url(#IosIcon_0476552ee01d2702__a)",
  d: "M0 0h61v26H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-bright,#c5a0ef)",
  mask: "url(#IosIcon_0476552ee01d2702__b)",
  d: "M0 0h61v26H0z"
}))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"61\" height=\"26\" text-rendering=\"geometricPrecision\" viewBox=\"0 0 61 26\"><defs><mask id=\"layer-0\" width=\"61\" height=\"26\" x=\"0\" y=\"0\" mask-type=\"alpha\" maskUnits=\"userSpaceOnUse\"><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAaCAMAAAAzFaRVAAAAJFBMVEVMaXH///////////////////////////////////////////9tKdXLAAAAC3RSTlMAhtw7WyAQo+9wv5+I+9sAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAACOSURBVHja1ZSxEsMwCEMtsIMd/f//ts3lkiuZZC+tFqZ3EmBcyl9pG+HTcDP2Ok0H60JwYK5fB0Z7Rx+AbF87P4o4imk8yKNeRWmgndQlmkDvD7gJE0twoUvBE9zLCm3SrnPyvim4ZXNo685jC8HdH7Q09X1pbv792DTr3DnVO8XtTupHXo2nbOV7+Qm9ALxNA35FlXH/AAAAAElFTkSuQmCC\" width=\"61\" height=\"26\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAaCAMAAAAzFaRVAAAAJFBMVEVMaXH///////////////////////////////////////////9tKdXLAAAAC3RSTlMAhtw7WyAQo+9wv5+I+9sAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAACOSURBVHja1ZSxEsMwCEMtsIMd/f//ts3lkiuZZC+tFqZ3EmBcyl9pG+HTcDP2Ok0H60JwYK5fB0Z7Rx+AbF87P4o4imk8yKNeRWmgndQlmkDvD7gJE0twoUvBE9zLCm3SrnPyvim4ZXNo685jC8HdH7Q09X1pbv792DTr3DnVO8XtTupHXo2nbOV7+Qm9ALxNA35FlXH/AAAAAElFTkSuQmCC\" preserveAspectRatio=\"none\" style=\"image-rendering:crisp-edges\"/></mask><mask id=\"layer-1\" width=\"61\" height=\"26\" x=\"0\" y=\"0\" mask-type=\"alpha\" maskUnits=\"userSpaceOnUse\"><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAaCAMAAAAzFaRVAAAABlBMVEVMaXH///+a4ocPAAAAAXRSTlMAQObYZgAAAAlwSFlzAAAD6AAAA+gBtXtSawAAACpJREFUeNpjYBgFo4AWgBEE4BQ5mqGAIs2jugfCcjpHOIW6GSjROwrgAACFZQCU65G+PQAAAABJRU5ErkJggg==\" width=\"61\" height=\"26\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAaCAMAAAAzFaRVAAAABlBMVEVMaXH///+a4ocPAAAAAXRSTlMAQObYZgAAAAlwSFlzAAAD6AAAA+gBtXtSawAAACpJREFUeNpjYBgFo4AWgBEE4BQ5mqGAIs2jugfCcjpHOIW6GSjROwrgAACFZQCU65G+PQAAAABJRU5ErkJggg==\" preserveAspectRatio=\"none\" style=\"image-rendering:crisp-edges\"/></mask></defs><image xlink:href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAaCAMAAAAzFaRVAAAAPFBMVEVMaXEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC1b/zcwfi8gPvPp/nCjfvproBqAAAADnRSTlMAvqDvEIBgIEHfz49wMGeLi9AAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAADsSURBVHja7ZTbbgMhDES5GwNrCPn/fy2YkIYVSqMqL1E7D+yAOMIe0Arxr0/TISW0j7EBUTpe6j4oeIX2RG3foYkV2wrg8Pa081pKzULkWup1oTsQXUJGFFHyXp3pwmOt4/NIJyIuWpI2bQjdww4+T5iWJOfEC0uE7tx1XmaXhdazzF6DCb3r4Namn6T2QKc2Otl59SqNt63QK+dL8zjtrvK80JE0N6r4AtiaW5Bb1YX2HNQRuVxJyh8Q17PXzO+Hj9dixwMhBGFw+n3Mm7c2gtLW9JpTuPsfL3zKAGz9m/Qde8m/4i+s/Nd/TF/Digu2wmvf5QAAAABJRU5ErkJggg==\" id=\"convert2-underlay\" width=\"61\" height=\"26\" href=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAAaCAMAAAAzFaRVAAAAPFBMVEVMaXEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC1b/zcwfi8gPvPp/nCjfvproBqAAAADnRSTlMAvqDvEIBgIEHfz49wMGeLi9AAAAAJcEhZcwAAA+gAAAPoAbV7UmsAAADsSURBVHja7ZTbbgMhDES5GwNrCPn/fy2YkIYVSqMqL1E7D+yAOMIe0Arxr0/TISW0j7EBUTpe6j4oeIX2RG3foYkV2wrg8Pa081pKzULkWup1oTsQXUJGFFHyXp3pwmOt4/NIJyIuWpI2bQjdww4+T5iWJOfEC0uE7tx1XmaXhdazzF6DCb3r4Namn6T2QKc2Otl59SqNt63QK+dL8zjtrvK80JE0N6r4AtiaW5Bb1YX2HNQRuVxJyh8Q17PXzO+Hj9dixwMhBGFw+n3Mm7c2gtLW9JpTuPsfL3zKAGz9m/Qde8m/4i+s/Nd/TF/Digu2wmvf5QAAAABJRU5ErkJggg==\" preserveAspectRatio=\"none\"/><g shape-rendering=\"crispEdges\"><rect width=\"61\" height=\"26\" fill=\"var(--theme-primary, #810ea9)\" mask=\"url(#layer-0)\"/><rect width=\"61\" height=\"26\" fill=\"var(--theme-bright,#c5a0ef)\" mask=\"url(#layer-1)\"/></g></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/IosIcon.0476552ee01d27023212834962328358.svg"),
        {
          React: SvgIosIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      